import pclnExperimentation from '@pcln/experimentation';
/**
 * useSeti reads from pcln/experimentation
 * @public
 */
export const useSeti = ({
  testName,
  shouldFireImpression
}) => {
  if (shouldFireImpression) {
    pclnExperimentation.fireImpression(testName);
  }
  return pclnExperimentation.isVariant(testName);
};